import '../styles.scss';
import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import RelatorioService from 'services/relatorio-service';
import RepresentadaService from 'services/representada-service';
import PedidoService from 'services/pedido-service';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import lib from '../../../helpers/lib';
import Skeleton from 'react-loading-skeleton';

export default function FaturamentoPrecoMedio() {
  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();

  const [isLoading, setIsLoading] = React.useState(true);

  const [representadas, setRepresentadas] = React.useState([]);
  const [vendedores, setVendedores] = React.useState([]);
  const [categorias, setCategorias] = React.useState([]);
  const [totalCategorias, setTotalCategorias] = React.useState([]);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    mes: m + 1,
    ano: y
  });

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);

  useEffect(() => {
    (async () => {
      await getRepresentadas();
      getSelectListVendedor();
    })();
  }, []);

  useEffect(() => {
    if (loadedRepresentadas && loadedVendedores) {
      getFaturamentoPrecoMedio();
    }
  }, [loadedRepresentadas, loadedVendedores]);

  // useEffect(() => {
  //   (async () => {
  //     if (categorias.length > 0) {
  //       let catTotal = {
  //         nomeCategoria: '',
  //         precoMedioMesAnterior: categorias.reduce(
  //           (acc, item) => acc + item.precoMedioMesAnterior,
  //           0
  //         ),
  //         precoMedioFaturado: categorias.reduce((acc, item) => acc + item.precoMedioFaturado, 0),
  //         precoMedioMeta: categorias.reduce((acc, item) => acc + item.precoMedioMeta, 0),
  //         porcentagemPrecoMedioFaturado: null
  //       };

  //       // catTotal.porcentagemPrecoMedioFaturado =
  //       //   catTotal.precoMedioMeta != 0
  //       //     ? +((catTotal.precoMedioFaturado / catTotal.precoMedioMeta) * 100).toFixed(2)
  //       //     : 0;

  //       setTotalCategorias([catTotal]);
  //     }
  //   })();
  // }, [categorias]);

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();
    if (response?.data) {
      setRepresentadas(response?.data?.data[0]?.options);

      setFilter((prevFilter) => ({
        ...prevFilter,
        representadaId: response?.data?.data[0]?.options[0]?.value
      }));
    }
    setLoadedRepresentadas(true);
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();
    if (vendedores.data) {
      setVendedores(vendedores.data.data);

      if (vendedores.data.data.length == 1) {
        setFilter((prevFilter) => ({ ...prevFilter, vendedorId: vendedores.data.data[0].value }));
      }
    }
    setLoadedVendedores(true);
  }

  async function getFaturamentoPrecoMedio() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getFaturamentoPrecoMedio(filter);

    if (resultStatus.data) {
      setCategorias(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getExtratoPrecoMedio() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoPrecoMedio(filter);

    if (response?.data) {
      let fileName = `faturamento_preco_medio_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <Layout>
      <PageTitleCard title="Preco Médio" icon={<FontAwesomeIcon icon={faDollarSign} />} />

      <div className="background-relatorio">
        <div className="row filter-bar2 mb-5">
          <div className="col-lg-2">
            <label>Representada</label>
            <Select
              isClearable={false}
              // clearValue={() => {
              //   setFilter({ ...filter, representadaId: null });
              // }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={representadas}
              value={representadas?.find((x) => x.value === filter.representadaId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, representadaId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Vendedor</label>
            <Select
              isClearable={vendedores && vendedores?.length > 1}
              clearValue={() => {
                setFilter({ ...filter, vendedorId: null });
              }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores?.find((x) => x.value === filter.vendedorId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, vendedorId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Mês</label>
            <Select
              className="select-form-control"
              value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
              options={lib.selectListMeses}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, mes: item.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Ano</label>
            <Select
              className="select-form-control"
              value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
              options={lib.selectListAnos}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, ano: item.value });
              }}
            />
          </div>

          <div className="col row">
            <div className="col-6"></div>

            <div className="col-3 align-content-end">
              {/* Botão Exportar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                  });
                  getExtratoPrecoMedio();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFileExcel} /> Exportar
              </button>
            </div>

            <div className="col-3 align-content-end">
              {/* Botão Filtrar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                    //pageNumber: 1
                  });
                  getFaturamentoPrecoMedio();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFilter} /> Filtrar
              </button>
            </div>
          </div>
        </div>

        {/* Lista Categorias ----------------------------------------------------------------- */}
        <div
          className="table-responsive table-historico mt-4"
          onCopy={(e) => lib.parseCopiedText(e)}
        >
          {!isLoading && categorias ? (
            <Table striped bordered hover width="100%" className="table-relatorio">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th>Mês Anterior</th>
                  <th>Mês Corrente</th>
                  <th>Objetivo</th>
                  <th>% Realizado</th>
                </tr>
              </thead>
              <tbody>
                {categorias.length > 0 ? (
                  ([...categorias, ...totalCategorias] || [])?.map((item, index) => (
                    <tr key={index} className={index + 1 >= categorias.length ? 'fw-700' : ''}>
                      <td>{item.nomeCategoria}</td>
                      <td>
                        {/* {item.precoMedioMesAnterior.toFixed(2)} */}
                        {item.precoMedioMesAnterior?.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL'
                        })}
                        {/* <span> ({item.porcentagemPrecoMedioMesAnterior}%)</span> */}
                      </td>
                      <td>
                        {/* {item.precoMedioFaturado.toFixed(2)} */}
                        {item.precoMedioFaturado?.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL'
                        })}
                      </td>
                      <td>
                        {/* {item.precoMedioMeta.toFixed(2)} */}
                        {item.precoMedioMeta?.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL'
                        })}
                      </td>
                      <td>
                        {item.porcentagemPrecoMedioFaturado != null ? (
                          <span>{lib.formatToNumeric(item.porcentagemPrecoMedioFaturado)}%</span>
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Skeleton count={10} />
          )}
        </div>
      </div>
    </Layout>
  );
}
